import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicsSection() {
  return (
    <section id="topics" className="mx-auto w-full max-w-[1400px] px-4 pt-14 md:px-8 md:pt-20">
      <div className="mb-5 flex items-center gap-3">
        <span className="block h-5 w-1 rounded-full bg-accent-500" />
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-50 md:text-xl">主题专题</h2>
          <p className="mt-1 text-xs text-foreground-400 md:text-sm">
            按主题打包的片单，快速找到你想看的方向
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={`/category?topic=${topic.id}`}
            className="group relative block overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-colors hover:border-accent-500 cursor-pointer"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={topic.cover}
                alt={`${topic.name} 专题封面`}
                title={`${topic.name} - 欧美影视专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent" />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-foreground-950">
                {topic.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-100 group-hover:text-accent-400 transition-colors">
                {topic.name}
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-400">{topic.subtitle}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-secondary-300">
                进入专题
                <i className="ri-arrow-right-s-line text-base" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}